export namespace StylingUtils {
  export function getProgressStatusBackgroundColor(status: string) {
    if (status === "Not started" || status === "Locked") {
      return "bg-grey-30";
    }

    if (status === "In progress") {
      return "bg-orange-20";
    }

    if (status === "Completed") {
      return "bg-green-background";
    }

    if (status === "Attention") {
      return "bg-cta-red";
    }

    if (status === "Open") {
      return "bg-light-blue";
    }

    return "bg-green-background";
  }

  export function getProgressStatusTextColor(status: string) {
    if (status === "Not started" || status === "Locked") {
      return "text-grey-60";
    }

    if (status === "In progress") {
      return "text-orange-text";
    }

    if (status === "Completed") {
      return "text-green-text";
    }

    if (status === "Attention") {
      return "text-white";
    }

    if (status === "Open") {
      return "text-cta-blue";
    }

    return "text-orange-text";
  }

  export function getPauseStatusBackgroundColor(status: string) {
    if (status === "Paused") {
      return "bg-orange-20";
    }

    if (status === "Extension") {
      return "bg-orange-20";
    }

    if (status === "Pause & Hold") {
      return "bg-cta-red";
    }

    return "bg-green-background";
  }

  export function getPauseStatusTextColor(status: string) {
    if (status === "Paused") {
      return "text-orange-text";
    }

    if (status === "Extension") {
      return "text-orange-text";
    }

    if (status === "Pause & Hold") {
      return "text-white";
    }

    return "text-orange-text";
  }

  export function getFastTrackStatusBackgroundColor(status: string) {
    if (status === "Fast Track") {
      return "bg-green-background";
    }

    return "bg-grey-30";
  }

  export function getFastTrackStatusTextColor(status: string) {
    if (status === "Fast Track") {
      return "text-green-text";
    }

    return "text-grey-60";
  }
}
